import { VisibilityOutlined } from '@mui/icons-material';
import { IconButton, Tooltip } from '@mui/material';
import { Fragment } from 'react';

import { isMac } from '@/utils/isMac';

import { MARKDOWN_ACTION_GROUPS, MarkdownAction } from './markdownActions';

import s from './MarkdownToolbar.module.scss';

type Props = {
  disabled: boolean;
  /** Вместо поля показан отрендеренный текст — кнопки разметки неактивны */
  isPreview: boolean;
  onAction: (action: MarkdownAction) => void;
  onTogglePreview: () => void;
};

const hotkeyHint = (code: string) => `${isMac ? '⌘' : 'Ctrl+'}${code.replace('Key', '')}`;

/** Кнопки разметки над полем, как в Яндекс Трекере: жирный, списки, ссылки… */
const MarkdownToolbar: React.FC<Props> = ({ disabled, isPreview, onAction, onTogglePreview }) => (
  <div className={s.toolbar} role="toolbar" aria-label="Форматирование">
    {MARKDOWN_ACTION_GROUPS.map((group, index) => (
      <Fragment key={group[0].label}>
        {index > 0 && <span className={s.toolbar__divider} aria-hidden />}
        {group.map((action) => (
          <Tooltip
            key={action.label}
            title={action.hotkey ? `${action.label} · ${hotkeyHint(action.hotkey)}` : action.label}
            disableInteractive
          >
            <span>
              <IconButton
                size="small"
                aria-label={action.label}
                disabled={disabled || isPreview}
                // Не уводим фокус из поля: иначе потеряется выделение
                onMouseDown={(event) => event.preventDefault()}
                onClick={() => onAction(action)}
                sx={{ borderRadius: '6px', color: 'var(--primary-color)' }}
              >
                {action.icon}
              </IconButton>
            </span>
          </Tooltip>
        ))}
      </Fragment>
    ))}
    <Tooltip title={isPreview ? 'Вернуться к тексту' : 'Просмотр'} disableInteractive>
      <IconButton
        size="small"
        aria-label="Просмотр"
        aria-pressed={isPreview}
        disabled={disabled}
        onMouseDown={(event) => event.preventDefault()}
        onClick={onTogglePreview}
        sx={{
          marginLeft: 'auto',
          borderRadius: '6px',
          color: isPreview ? 'var(--accent-color)' : 'var(--secondary-color)',
          backgroundColor: isPreview ? 'var(--very-light-accent-color)' : undefined,
        }}
      >
        <VisibilityOutlined fontSize="small" />
      </IconButton>
    </Tooltip>
  </div>
);

export { MarkdownToolbar };
